"use strict";

import angular from "angular";

import template from "./youtube-player.component.html";
import "./themes/youtube-player.component.scss";

export class YoutubePlayerComponent {
    constructor($rootScope) {
        this.$rootScope = $rootScope;

        this.player = {};
        this.frameId = "";

        this.$rootScope.$on("ON_STOP_YT_PLATER", this.pauseVideo);
    }

    $onInit() {
        this.frameId = `Player_${this.videoId}`;

        this.onYoutubeframeAPIReady();
    }

    onYoutubeframeAPIReady() {
        setTimeout(() => {
            this.player = new YT.Player(this.frameId, {
                videoId: this.videoId,
                events: {}
            });
        }, 1000);
    }

    pauseVideo = () => {
        if (this.player.pauseVideo) this.player.pauseVideo();
    };
}

YoutubePlayerComponent.$inject = ["$rootScope"];

const name = "youtubePlayerComponent";
const def = {
    bindings: {
        videoId: "@",
        onpauseVideo: "<"
    },
    controller: YoutubePlayerComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
